import Cotter from "./Cotter";
import CotterEnum from "./enum";

class CotterExport extends Cotter {
  CotterEnum: CotterEnum;
}

export = CotterExport;
